import { useQuery } from 'react-query';

import { TEAM_KEY, TeamResponse, getTeam } from '../utils/backend-api/teams';
import useCurrentUser from './useCurrentUser';

export default function useTeam() {
  const { currentUser } = useCurrentUser();
  const { data, isLoading: isTeamLoading } = useQuery<TeamResponse>(
    [TEAM_KEY, currentUser.guid],
    () => getTeam(),
    {
      enabled: !!currentUser.guid,
    }
  );

  return { team: data?.team, isTeamLoading };
}
